/* ==========================================================================
   PLIXOVA — mobile menu + slide-out cart drawer
   Config comes from data-* attributes on [data-plx-cart], so this file stays
   plain JavaScript with no Liquid inside. Rows are built with DOM APIs
   (textContent escapes automatically) rather than HTML strings.
   ========================================================================== */

(function () {
  'use strict';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== null && text !== undefined) n.textContent = text;
    return n;
  }

  function initMenu() {
    var btn = document.querySelector('[data-plx-menu-toggle]');
    var nav = document.querySelector('[data-plx-mobile-nav]');
    if (!btn || !nav || btn.dataset.plxBound) return;
    btn.dataset.plxBound = 'true';
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        nav.classList.remove('is-open');
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initCart() {
    var root = document.querySelector('[data-plx-cart]');
    if (!root || root.dataset.plxBound) return;
    root.dataset.plxBound = 'true';

    var CURRENCY = root.getAttribute('data-currency') || 'USD';
    var EMPTY_TEXT = root.getAttribute('data-empty-text') || 'Your cart is empty';
    var CONTINUE_TEXT = root.getAttribute('data-continue-text') || 'Continue shopping';
    var SHOP_URL = root.getAttribute('data-shop-url') || '/';

    var body = root.querySelector('[data-plx-cart-body]');
    var foot = root.querySelector('[data-plx-cart-foot]');
    var subtotalEl = root.querySelector('[data-plx-cart-subtotal]');

    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function setCount(n) {
      document.querySelectorAll('[data-plx-cart-qty]').forEach(function (node) {
        node.textContent = n;
      });
      document.querySelectorAll('[data-plx-cart-count]').forEach(function (node) {
        node.textContent = n;
        node.hidden = n === 0;
      });
    }

    function lineButton(line, to, label, aria, cls) {
      var b = el('button', cls, label);
      b.type = 'button';
      b.setAttribute('data-plx-line', line);
      b.setAttribute('data-plx-to', to);
      b.setAttribute('aria-label', aria);
      return b;
    }

    function render(cart) {
      setCount(cart.item_count);
      body.textContent = '';

      if (!cart.items || !cart.items.length) {
        var empty = el('div', 'plx-cart__empty');
        empty.appendChild(el('p', null, EMPTY_TEXT));
        var link = el('a', 'plx-btn plx-btn--secondary plx-btn--small', CONTINUE_TEXT);
        link.href = SHOP_URL;
        empty.appendChild(link);
        body.appendChild(empty);
        foot.hidden = true;
        return;
      }

      cart.items.forEach(function (item, i) {
        var line = i + 1;
        var row = el('div', 'plx-cart__item');

        if (item.image) {
          var img = el('img', 'plx-cart__item-img');
          img.src = item.image + '&width=160';
          img.alt = '';
          img.width = 64;
          img.height = 64;
          img.loading = 'lazy';
          row.appendChild(img);
        } else {
          row.appendChild(el('span', 'plx-cart__item-img'));
        }

        var info = el('div', 'plx-cart__item-info');
        info.appendChild(el('p', 'plx-cart__item-title', item.product_title));
        if (item.variant_title) {
          info.appendChild(el('p', 'plx-cart__item-variant', item.variant_title));
        }

        var qty = el('div', 'plx-cart__qty');
        qty.appendChild(lineButton(line, item.quantity - 1, String.fromCharCode(8722), 'Decrease quantity', null));
        qty.appendChild(el('span', null, item.quantity));
        qty.appendChild(lineButton(line, item.quantity + 1, '+', 'Increase quantity', null));
        info.appendChild(qty);
        row.appendChild(info);

        var right = el('div', 'plx-cart__item-right');
        right.appendChild(el('p', 'plx-cart__item-price', money(item.final_line_price)));
        right.appendChild(lineButton(line, 0, 'Remove', 'Remove item', 'plx-cart__remove'));
        row.appendChild(right);

        body.appendChild(row);
      });

      subtotalEl.textContent = money(cart.total_price);
      foot.hidden = false;
    }

    function load() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }

    function openCart() {
      root.hidden = false;
      document.body.classList.add('plx-no-scroll');
      /* Force a reflow so the slide-in transition runs. A rendering frame is
         not guaranteed here (background tabs throttle requestAnimationFrame),
         so never wait on one to reveal the panel. */
      void root.offsetWidth;
      root.classList.add('is-open');
      load();
    }

    function closeCart() {
      root.classList.remove('is-open');
      document.body.classList.remove('plx-no-scroll');
      window.setTimeout(function () { root.hidden = true; }, 300);
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-plx-cart-open]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-plx-cart-close]')) { e.preventDefault(); closeCart(); return; }

      var btn = e.target.closest('[data-plx-line]');
      if (!btn) return;
      e.preventDefault();
      body.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: parseInt(btn.getAttribute('data-plx-line'), 10),
          quantity: parseInt(btn.getAttribute('data-plx-to'), 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { body.classList.remove('is-busy'); render(cart); })
        .catch(function () { body.classList.remove('is-busy'); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeCart();
    });

    document.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var addBtn = form.querySelector('[name=add]');
      var label = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding...'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = label; }
          if (data && data.status && data.status !== 200) { form.submit(); return; }
          openCart();
        })
        .catch(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = label; }
          form.submit();
        });
    });

    load();
  }

  function init() { initMenu(); initCart(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();